import { Box, Text } from '@chakra-ui/react'
import { isEqual } from 'lodash-es'
import { memo, useState } from 'react'

import type { SerializedRichText } from '@/client/services/richText/types'

import RichText from '@/components/UI/RichTextEditor/RichText'

const MAX_HEIGHT_PIXELS = 250

function PostBodyInternal({
  body,
  truncateIfLong = false,
  truncationMessage = 'See more',
}: {
  body: SerializedRichText
  truncateIfLong?: boolean
  truncationMessage?: string
}): JSX.Element {
  const [bodyRef, setBodyRef] = useState<HTMLDivElement | null>(null)

  return (
    <Box position="relative">
      <Box
        ref={setBodyRef}
        maxHeight={truncateIfLong ? `${MAX_HEIGHT_PIXELS}px` : 'auto'}
        overflowY="hidden"
      >
        <RichText content={body} />
      </Box>
      {bodyRef != null && bodyRef.scrollHeight > MAX_HEIGHT_PIXELS && truncateIfLong ? (
        <Text fontWeight="bold" mt="16px" color="fg.subtle">
          {truncationMessage}
        </Text>
      ) : null}
    </Box>
  )
}

const PostBody = memo(PostBodyInternal, isEqual)

export default PostBody
